export default __webpack_public_path__ + "static/media/step_G_1@2x.c5aa902d.png";